module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fornecedor/fornecedor.component.css
// module id = ./src/app/fornecedor/fornecedor.component.css
// module chunks = main